module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("T"), _c('span', {
    staticClass: "small2"
  }, [_vm._v("HE")]), _vm._v(" C"), _c('span', {
    staticClass: "small2"
  }, [_vm._v("OMANCHE")]), _c('br'), _vm._v("E"), _c('span', {
    staticClass: "small2"
  }, [_vm._v("MPIRE")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_vm._v("Pekka Hämäläinen")]), _vm._v(" "), _c('p', {
    staticClass: "pub"
  }, [_c('i', [_vm._v("Published in Association with The William P. Clements Center for"), _c('br'), _vm._v("Southwest Studies, Southern Methodist University")]), _c('br'), _c('br'), _vm._v(" "), _c('i', [_vm._v("Yale University Press"), _c('br'), _vm._v("New Haven & London")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67484a85","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/titlepage.vue
// module id = 63
// module chunks = 0